import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X, Zap, Clock, TrendingUp, Star, CheckCircle2 } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
const promoIcons = [Star, Clock, Zap, TrendingUp, CheckCircle2];
const WHATSAPP_URL = 'https://wa.me/447311754270?text=WEBSITE';
const VISIBLE_MS = 6500;
const HIDDEN_MS = 9000;
const FIRST_DELAY_MS = 4000;
export function PromoPopup() {
  const {
    t
  } = useLang();
  const promos = t.promo.items;
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [closed, setClosed] = useState(false);
  const timers = useRef<number[]>([]);
  const clearTimers = () => {
    timers.current.forEach(timer => clearTimeout(timer));
    timers.current = [];
  };
  useEffect(() => {
    if (closed) {
      clearTimers();
      setOpen(false);
      return;
    }
    let i = 0;
    const showNext = (delay: number) => {
      const showTimer = window.setTimeout(() => {
        setIndex(i % promos.length);
        setOpen(true);
        const hideTimer = window.setTimeout(() => {
          setOpen(false);
          i += 1;
          showNext(HIDDEN_MS);
        }, VISIBLE_MS);
        timers.current.push(hideTimer);
      }, delay);
      timers.current.push(showTimer);
    };
    showNext(FIRST_DELAY_MS);
    return clearTimers;
  }, [closed, promos.length]);
  const promo = promos[index];
  const Icon = promoIcons[index];
  return <AnimatePresence data-id="element-461" data-mp="unq0ohe55doo">
      {open && !closed && <motion.div initial={{
      opacity: 0,
      x: -40,
      y: 10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -40
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 22
    }} className="fixed bottom-5 left-5 z-50 w-[300px] max-w-[calc(100vw-2.5rem)]" data-id="element-462" data-mp="po3pselsc9j1">
          <div className="relative bg-dark-100 border border-gold/30 rounded-2xl p-4 pr-9 shadow-[0_12px_40px_rgba(0,0,0,0.6)] overflow-hidden" data-id="element-463" data-mp="2fxet5bql9jyq">
            {/* subtle gold glow */}
            <div className="absolute -top-8 -right-8 w-24 h-24 bg-gold/10 rounded-full blur-2xl pointer-events-none" data-id="element-464" data-mp="2i2tiv49a4a1u" />

            <button onClick={() => setClosed(true)} aria-label={t.promo.closeLabel} className="absolute top-2.5 right-2.5 text-gray-500 hover:text-white transition-colors" data-id="element-465" data-mp="2n4ivupg2axsk">
              <X className="w-4 h-4" data-id="element-466" data-mp="1zd3p8kh95ubi" />
            </button>

            <div className="relative flex items-start gap-3" data-id="element-467" data-mp="1zeolcej7tlbh">
              <div className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gold/15 text-gold" data-id="element-468" data-mp="24b5a9ay8o3pm">
                <Icon className="w-5 h-5" data-id="element-469" data-mp="299gi5g4z4457" />
              </div>
              <div className="min-w-0" data-id="element-470" data-mp="2e29no689ngic">
                <p className="text-white font-bold text-sm leading-tight" data-id="element-471" data-mp="2e3ax669mvuxy">
                  {promo.title}
                </p>
                <p className="text-gray-400 text-xs mt-0.5 leading-snug" data-id="element-472" data-mp="1gkja05uh7nq6">
                  {promo.message}
                </p>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-xs font-bold text-gold hover:text-gold-400 transition-colors" data-id="element-473" data-mp="2qudq55t1yh7">
                  {t.promo.cta}
                </a>
              </div>
            </div>

            {/* progress bar */}
            <motion.div key={index} initial={{
          scaleX: 1
        }} animate={{
          scaleX: 0
        }} transition={{
          duration: VISIBLE_MS / 1000,
          ease: 'linear'
        }} className="absolute bottom-0 left-0 h-0.5 w-full bg-gold/60 origin-left" data-id="element-474" data-mp="3fwm5kqum5n4s" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}